export const userRoleEnums = Object.freeze({
  OWNER: 'OWNER',
  ATTENDANT: 'ATTENDANT',
})
